import routerOptions0 from "/tmp/workspace/staging/revex/memberships-preview/node_modules/.pnpm/nuxt@3.21.2_@emnapi+core@1.5.0_@emnapi+runtime@1.5.0_@parcel+watcher@2.5.6_@types+node@24.5.2_urso7s5pdtztcugyzjfxt3pvs4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}